import auth from './auth';
import reg from './reg';

export default {
  auth,
  reg,
};


// WEBPACK FOOTER //
// ./src/shared/reducers/index.js